import { render, staticRenderFns } from "./InspectionFollowUpWork.vue?vue&type=template&id=652261ca&"
import script from "./InspectionFollowUpWork.vue?vue&type=script&lang=js&"
export * from "./InspectionFollowUpWork.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports